import cn from 'classnames';
import { ChangeEvent, FC, ReactNode } from 'react';

import styles from './Checkbox.module.scss';

export type CheckboxProps = {
  checked: boolean;
  onChange: (event: boolean | ChangeEvent<Element>) => void;
  className?: string;
  boxClassName?: string;
  testID?: string;
  disabled?: boolean;
  error?: string;
  name?: string;
  children?: ReactNode;
  id?: string;
  required?: boolean;
};

export const Checkbox: FC<CheckboxProps> = ({
  checked,
  className,
  boxClassName,
  testID,
  disabled = false,
  onChange,
  error = '',
  name,
  children,
  id,
  required,
}) => (
  <label
    id={id}
    className={cn(
      styles.container,
      disabled && styles.disabled,
      'p2',
      className,
    )}
    data-testid={testID}
  >
    <input
      type="checkbox"
      className={cn(styles.input, error && styles.isError)}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      name={name}
    />
    <div className={cn(styles.checkbox, boxClassName)} />

    <div className={styles.content}>
      {children}

      {error && required && (
        <p className={cn(styles.errorMessage, 'p4')}>{error}</p>
      )}
    </div>
  </label>
);
